module.exports = __webpack_public_path__ + "static/media/FromLittleTokyoWithLoveBookCover.276eb3e1.jpg";